import { API_BASE_URL, api } from './client'
import type { Grower } from './growers-api'

// Self-service household endpoints. A grower login has care_logs.* but neither
// growers.read nor files.read (both unscoped, they would expose every
// household's PII), so it reads its OWN household through these grower-scoped
// routes instead of the agriculture ones. The server answers 404 for any
// household not linked to the caller.
export const myGrowerApi = {
    /** Full detail (general info, profile, bank, areas, files) of one own household. */
    detail: (growerId: string) =>
        api.get<Grower>(`/care-logs/my-growers/${growerId}`),
}

/**
 * Download URL for a document attached to the caller's own household. Household
 * documents (CCCD…) are private uploads, so the generic /files/:id/download
 * route is not reachable by a grower login — this scoped route is.
 */
export function myGrowerFileDownloadUrl(
    growerId: string,
    fileId: string,
): string {
    return `${API_BASE_URL}/care-logs/my-growers/${growerId}/files/${fileId}/download`
}
